module.exports = __webpack_public_path__ + "static/media/football-carousel-2-1024x1366.660b80d8.jpg";